/**
 * 훑기가 제안한 데이터셋 후보.
 *
 * 후보는 **아직 데이터셋이 아니다.** 사람이 수락해야 목록에 들어가고, 폐기하면 훑기가 다시 봐도
 * 제안하지 않는다 — 가역적인 숨김(`hiddenAt`)과 다른 개념이라 화면에서도 다른 말로 쓴다.
 *
 * Owns:
 * - 화면이 다루는 후보 값과 상태 어휘.
 *
 * Does not own:
 * - wire 응답 해석 — `api/candidateApi.ts`. 표시 문구 — `feature/datasetFormatters.ts`.
 */
import type { DatasetFormat } from "./dataset";

/** 후보 하나가 지나는 상태 — 되돌아오는 전이는 없다. */
export type CandidateState = "discovered" | "accepted" | "dismissed";

export const CANDIDATE_STATES: readonly CandidateState[] = ["discovered", "accepted", "dismissed"];

export type Candidate = {
  uuid: string;
  /** 어느 훑기 루트가 찾았는지. 예) `"droid_output"`. */
  rootCode: string;
  /** 정규화된 원본 주소. 예) `az://droid-output/260909/_staging/ledger`. */
  sourceRef: string;
  format: DatasetFormat;
  formatVersion: string | null;
  /** 판정 근거 문장. 수집할 수 없는 후보에서는 그 이유를 적는다. */
  formatDetail: string | null;
  /** 수락한 뒤 Probe 를 받을 수 있는지. 서버가 판정한다. */
  canProbe: boolean;
  state: CandidateState;
  firstSeenAtMs: number;
  /** 훑기가 마지막으로 이 주소를 본 시각 — 사라진 원본이 여기서 드러난다. */
  lastSeenAtMs: number;
  dismissedReason: string | null;
};

/** 주소의 마지막 세그먼트 — 서버가 이름을 만들 때 쓰는 규칙과 같다. */
export function candidateDefaultName(candidate: Candidate): string {
  const segments = candidate.sourceRef.split("/").filter((part) => part !== "");
  return segments[segments.length - 1] ?? candidate.sourceRef;
}
